import { LoadingButton } from '@mui/lab'
import { Box, Button } from '@mui/material'
import i18n from 'i18n-js'
import { forwardRef, useImperativeHandle, useMemo, useState } from 'react'
import { InputAutoComplete, InputForm } from '../../../../components'
import BaseModal from '../../../../components/baseModal'
import { useStyles } from './styles'

export const ObservationModal = forwardRef(({
  openModal,
  handleCloseModal,
  lists,
  defaultData,
  onSave,
  isLoading,
  view, observationType,
  notSelect
}, ref) => {
  const [values, setValues] = useState(defaultData || {})
  const { styles } = useStyles()

  const handleChange = (item, name) => {
    setValues((prev) => ({ ...prev, [name]: item }))
  }

  const handleClose = () => {
    setValues({})
    handleCloseModal()
  }

  const handleSave = () => {
    onSave(values)
  }


  const title = useMemo(() => {
    if (defaultData) {
      return i18n.t(`observation.crud.edit`)
    }
    if (view) {
      return i18n.t(`observation.crud.detail`)
    }
    return i18n.t(`observation.crud.creation`)
  }, [defaultData, view, openModal])

  useImperativeHandle(ref, () => ({
    updateValue: (value) => {
      setValues(value)
    }
  }))

  const handleDisabled = () => {
    if (notSelect) {
      return isLoading || !values.observation?.length || values.observation?.length < 3
    }
    return (
      isLoading ||
      !values.patient ||
      !values.observation ||
      values.observation?.length < 3
    )
  }


  return (
    <BaseModal
      title={title}
      open={openModal}
      onClose={handleClose}
      modalProps={{
        sx: styles.modal,
      }}
    >
      <Box sx={styles.container}>
        {(!view && !notSelect) && (
          <InputAutoComplete
            value={values?.patient || null}
            label={i18n.t('general.patient')}
            onChange={(e, value) => {
              handleChange(value, 'patient')
            }}
            options={lists?.patient || []}
            renderOption={(props, option, index) => {
              const key = `listItem-${index}-${option.id}`

              return option.label ? (
                <li {...props} key={key}>
                  {option.label}
                </li>
              ) : (
                ''
              )
            }}
            getOptionLabel={(val) => val.label ?? ''}
            sx={styles.autocomplete}
          />
        )}

        {
          observationType && (
            <InputAutoComplete
              value={values?.observationType || lists?.observationTypes[0]}
              label={i18n.t('observation.observationType')}
              onChange={(e, value) => {
                handleChange(value || lists?.observationTypes[0], "observationType")
              }}
              options={lists?.observationTypes || []}
              renderOption={(props, option, index) => {
                const key = `listItem-${index}-${option.id}`

                return option.label ? (
                  <li {...props} key={key}>
                    {option.label}
                  </li>
                ) : (
                  ''
                )
              }}
              getOptionLabel={(val) => val.label ?? ''}
              sx={styles.autocomplete}
            />
          )
        }

        {!view && (
          <InputForm
            color="secondary"
            onChange={(e) => {
              handleChange(e.target.value, 'observation')
            }}
            name="start"
            label={i18n.t('observation.crud.textArea')}
            fullWidth
            multiline
            value={values?.observation || ""}
            maxRows={4}
            minRows={4}
          />
        )}

        <Box sx={styles.footer}>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={handleClose}
          >
            {i18n.t('components.cancel')}
          </Button>

          <LoadingButton
            loading={isLoading}
            variant="contained"
            color="secondary"
            size="small"
            type="submit"
            onClick={handleSave}
            disabled={handleDisabled()}
          >
            {defaultData
              ? i18n.t('components.update')
              : i18n.t('components.increment')}
          </LoadingButton>
        </Box>
      </Box>
    </BaseModal>
  )
})
ObservationModal.displayName = 'ObservationModal'